export default "assets/images/icons/marker-d40ef61f.svg";